// @flow
import gql from 'graphql-tag';
import { apolloQuery } from '../../core/data/apolloClient';

export function listOfflineBranches(shape: string) {
  return apolloQuery(
    gql`query {
          listOfflineBranches ${shape}
        }`,
    {}
  );
}

export function listOfflineCuts(officeId: string, date: string, shape: string) {
  return apolloQuery(
    gql`query ($officeId: String!, $date: String!) {
          listOfflineCuts(officeId: $officeId, date: $date) ${shape}
        }`,
    { officeId, date }
  );
}

export function listOfflineDays(officeId: string, shape: string) {
  return apolloQuery(
    gql`query ($officeId: String!) {
          listOfflineDays(officeId: $officeId) ${shape}
        }`,
    { officeId }
  );
}
